import React from "react";
import Table from "../../../../components/tables/Table";
import { ICarrierStateAppointed } from "../types";

interface ICarrierStateAppointedProps {
  data?: ICarrierStateAppointed[];
}
const CarrierStateAppointedTable = ({ data }: ICarrierStateAppointedProps) => {
  const columns = [
    {
      name: "State",
      cell: (row) => row.states,
      sortable: true,
    },
    {
      name: "New Business",
      cell: (row) => {
        return (
          <div className="text-xs3 items-left text-left">
            {row.newBusiness ? "Yes" : "No"}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Renewal Business",
      cell: (row) => {
        return <div>{row.renewalBusiness ? "Yes" : "No"}</div>;
      },
      sortable: true,
    },
    {
      name: "New Business Suspended",
      cell: (row) => {
        return <div>{row.newBusinessSuspended ? "Yes" : "No"}</div>;
      },
      sortable: true,
    },
    {
      name: "New Business Suspended Date",
      cell: (row) => {
        return (
          <div>
            {row.newBusinessSuspendedDate
              ? new Date(row.newBusinessSuspendedDate).toLocaleDateString()
              : ""}
          </div>
        );
      },
      sortable: true,
    },
  ];

  return (
    <div className="space-y-5 mt-5 ">
      <Table
        columns={columns}
        data={data}
        loading={false}
        selectableRows={false}
        expandableRowsComponent={undefined}
        onSelectedRowsChange={undefined}
        clearSelectedRows={undefined}
        setOpenModal={undefined}
        expandableRowExpanded={undefined}
      />
    </div>
  );
};

export default CarrierStateAppointedTable;
